module.exports = __webpack_public_path__ + "static/artist-development-the-process-mobile-54f11166288fcf01c7b580c7bcbff9c3.webp";